import React from "react";
import { CalendarIcon, Clock, User, Tag } from "lucide-react";
interface BlogMetaProps {
  date: string;
  lastUpdated?: string;
  author?: string;
  tags?: string[];
}
const BlogMeta: React.FC<BlogMetaProps> = ({
  date,
  lastUpdated,
  author = "Jörg Hörmann",
  tags = []
}) => {
  // Format helper function
  const formatDateToISO = (dateString: string): string | null => {
    if (dateString === "In Vorbereitung") return null;
    
    try {
      // Split by dots or slashes (DD.MM.YYYY or DD/MM/YYYY)
      const parts = dateString.split(/[./]/);
      if (parts.length === 3) {
        const day = parts[0].trim();
        const month = parts[1].trim();
        const year = parts[2].trim();
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
      
      // Handle format: "04. März 2025"
      if (dateString.includes(' ')) {
        const parts = dateString.split(' ');
        if (parts.length === 3) {
          const day = parts[0].replace('.', '').trim();
          const monthMap: Record<string, string> = {
            'Januar': '01', 'Februar': '02', 'März': '03', 'April': '04',
            'Mai': '05', 'Juni': '06', 'Juli': '07', 'August': '08',
            'September': '09', 'Oktober': '10', 'November': '11', 'Dezember': '12'
          };
          const month = monthMap[parts[1]] || '01';
          const year = parts[2];
          return `${year}-${month}-${day.padStart(2, '0')}`;
        }
      }
    } catch (error) {
      console.error("Error formatting date:", error);
      return null;
    }
    return null;
  };
  
  const formattedDate = formatDateToISO(date);
  const formattedUpdateDate = lastUpdated ? formatDateToISO(lastUpdated) : null;
  const showUpdateDate = formattedUpdateDate && formattedUpdateDate !== formattedDate;
  return <div className="mb-8">
      <div className="flex flex-wrap gap-4 mb-6" aria-label="Artikel Informationen">
        {formattedDate && <span className="inline-flex items-center text-sm text-joerg-500">
            <CalendarIcon className="mr-2 h-4 w-4" aria-hidden="true" />
            <time dateTime={formattedDate} itemProp="datePublished">Veröffentlicht: {date}</time>
          </span>}
        
        {!formattedDate && <span className="inline-flex items-center text-sm text-joerg-500 italic">
            <CalendarIcon className="mr-2 h-4 w-4" aria-hidden="true" />
            <span>{date}</span>
          </span>}
        
        {showUpdateDate && <span className="inline-flex items-center text-sm text-joerg-600 font-medium">
            <CalendarIcon className="mr-2 h-4 w-4" aria-hidden="true" />
            <time dateTime={formattedUpdateDate!} itemProp="dateModified">Aktualisiert: {lastUpdated}</time>
          </span>}
        
        <span className="inline-flex items-center text-sm text-joerg-500">
          <User className="mr-2 h-4 w-4" aria-hidden="true" />
          <span itemProp="author" itemScope itemType="https://schema.org/Person">
            <span itemProp="name">{author}</span>
          </span>
        </span>
      </div>
      
      {/* Tags section */}
      {tags && tags.length > 0 && <div className="flex flex-wrap gap-2 mt-4">
          {tags.map((tag, index) => (
            <span 
              key={index}
              className="inline-flex items-center text-xs text-joerg-600 bg-joerg-100 px-2 py-1 rounded-full"
            >
              <Tag className="mr-1 h-3 w-3" aria-hidden="true" />
              {tag}
            </span>
          ))}
        </div>}
    </div>;
};
export default BlogMeta;